<template>
    <div id="main">
        <div v-if="!activeSensor">
            <header><h1>Sensors Codert</h1></header>
            <div class="container">
                <div>
                    <h2>Znane czujniki</h2>
                    <div class="sensors-container">
                        <div v-for="(sensorName, id) in selectedSensors"
                             :key="id"
                             class="item"
                             @click="activeSensor = id"
                        >
                            <h5>{{sensorName}}</h5>
                            <Sensor :id="id"></Sensor>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <b-button @click="showOtherSensors = !showOtherSensors">
                        <template v-if="!showOtherSensors">Pokaż pozostałe czujniki</template>
                        <template v-else>Ukryj pozostałe czujniki</template>
                    </b-button>
                    <div class="sensors-container" v-if="showOtherSensors">
                        <div v-for="sensor in otherSensors"
                             :key="sensor.id"
                             class="item"
                             @click="activeSensor = sensor.id"
                        >
                            <h5>{{ sensor.name }}</h5>
                            <Sensor :id="sensor.id"></Sensor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeSensor">
            <header>
                <div class="container position-relative">
                    <font-awesome-icon
                            id="back-icon"
                            :icon="['fas', 'arrow-left']"
                            @click="activeSensor = null"/>
                    <template v-if="selectedSensors[activeSensor]">
                        <h1
                                contenteditable="true"
                                :innerText="selectedSensors[activeSensor]"
                                @blur="(e) => { $set(selectedSensors, activeSensor, e.target.innerText)}"
                        >{{ selectedSensors[activeSensor] }}</h1>
                    </template>
                    <template v-else>
                        <h1>{{ getSensorName(activeSensor) }}</h1>
                    </template>
                </div>
            </header>
            <div class="container">
                <Sensor :id="activeSensor" chart="true"></Sensor>
            </div>
            <div class="mt-3">
                <template v-if="typeof selectedSensors[activeSensor] === 'undefined'">
                    <b-button @click="$set(selectedSensors, activeSensor, getSensorName(activeSensor))">Przypnij
                    </b-button>
                </template>
                <template v-else>
                    <b-button @click="$delete(selectedSensors, activeSensor)">Odepnij</b-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Sensor from "@/components/Sensor";
    import SensorsAPIClient from "./utils/SensorsAPIClient";

    export default {
        name: 'app',
        data: function () {
            return {
                activeSensor: null,
                selectedSensors: {
                    32: "Na dworze",
                    30: "Piec 1",
                    29: "Bojler",
                    31: "Jermolonek (Piec 2)"
                },
                sensors: [],
                showOtherSensors: false
            }
        },
        components: {
            Sensor
        },
        computed: {
            otherSensors() {
                let results = [];
                for (let sensor of this.sensors) {
                    if (typeof this.selectedSensors[sensor.id] === 'undefined') {
                        results.push(sensor);
                    }
                }
                return results
            }
        },
        mounted() {
            let tmp = JSON.parse(localStorage.getItem('selectedSensors'));
            if (typeof tmp !== 'undefined' && tmp != null) {
                this.selectedSensors = tmp;
            }
            this.fetchSensors();
        },
        methods: {
            switchToDetailView(sensorID) {
                this.activeSensor = sensorID;
            },
            fetchSensors() {
                let saClient = new SensorsAPIClient();
                saClient.getSensors()
                    .then((results) => {
                        this.sensors = results;
                    });
            },
            getSensorName(sensorId) {
                if (typeof this.selectedSensors[sensorId] !== 'undefined') {
                    return this.selectedSensors[sensorId];
                }
                for (let sensor of this.sensors) {
                    if (sensor.id === sensorId) {
                        return sensor.name;
                    }
                }
                return 'unknown name'
            }
        },
        watch: {
            selectedSensors: {
                deep: true,
                handler() {
                    localStorage.setItem('selectedSensors', JSON.stringify(this.selectedSensors))
                }
            }
        }
    }
</script>

<style>
    #main {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #main header {
        background-color: #42b883;
        color: white;
        height: 50px;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
    }

    #main header h1 {
        font-size: 2rem;
        margin-bottom: 0;
        margin-top: 5px;
    }

    #main h5 {
        font-size: 1.25rem;
        height: 2.5rem;
        line-height: 1.2rem;
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin: 0;
    }

    .sensors-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .sensors-container .item {
        width: calc(50% - 10px);
        border-radius: 10px;
        padding: 10px;
        margin: 5px;
        box-sizing: border-box;
        border: solid 1px lightgray;
        background-color: whitesmoke;

    }

    #back-icon {
        position: absolute;
        left: 0;
        font-size: 2rem;
        margin: 9px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    /*@media (max-width: 1000px) {*/
    /*    .sensors-container .item{*/
    /*        min-width: 50%;*/
    /*    }*/
    /*}*/
    /*@media (max-width: 500px) {*/
    /*    .sensors-container .item{*/
    /*        min-width: 100%;*/
    /*    }*/
    /*}*/
</style>
